import type { TokenDefinition, } from "@bracket/sharedTypes/crypto";
import * as CHAIN_1_ASSETS from "./CHAIN_1_ASSETS";
import { logger, } from "@bracket/ui/logger";
import { isKnownChainId, type KnownChainId, type AssetMap, } from "@bracket/blocksmith/types";

type Chain1Imports = keyof typeof CHAIN_1_ASSETS;
export type AllChainImports = | Chain1Imports;


export const assets = new Map<KnownChainId, typeof CHAIN_1_ASSETS>([
	[ 1, CHAIN_1_ASSETS, ],
]);

export const getAssetMap = (chainId:KnownChainId = 1): ReturnType<typeof assets.get> => {
	if(isKnownChainId(chainId)) {
		const map = assets.get(chainId);
		if(map) {
			return map;
		}
	}
	throw new Error(`Unknown chain ID: ${chainId}`);
}

export const getAsset = (symbol: AllChainImports, chainId: KnownChainId = 1): TokenDefinition | undefined => {
	chainId === null ? 1 : chainId;
	const tokens = assets.get(chainId||1);
	try {
		if(tokens) {
			if(symbol in tokens) {
				return tokens[symbol];
			}
			logger.warn(`symbol "${symbol}" not found on chain ${chainId||1}`);
			return undefined;
		}
		logger.warn("TOKENS NOT FOUND", tokens);
	} catch(error) {
		console.error("GET ASSET ERROR", error);
		return undefined;
	}
}

export const isKnownAsset = ( symbol: AllChainImports, chainId: KnownChainId = 1 ): boolean => {
	const tokens = assets.get(chainId) || {};
	return symbol in tokens;
}


export const isKnownSymbol = <CID extends KnownChainId = 1>( symbol: AllChainImports, chainId: CID ): symbol is AllChainImports => {
	return isKnownAsset(symbol, chainId);
}
